import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { handleResponseArray } from "./APIHandlerHelper";
import { DeviceUser } from "../interfaces/Assignment";
import { WorkOrderAssignmentSubmission } from "../interfaces/WorkOrder";

interface Props {
  onAuthError?: () => void;
}

export default class AssignmentAPIs extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.WORK_API}/api/Assignment/`;

  getDeviceUsersByCustomerId = (customerId: number, assetId: number): Promise<DeviceUser[]> => {
    const apiAddress = `${AssignmentAPIs.BASE_URL}DeviceUsers/${customerId}/${assetId}`;
    return this.apiResponseHandler.get(apiAddress).then((data) => handleResponseArray(data));
  };

  unassignWorkOrder = async (workOrderId: number): Promise<any> => {
    const apiAddress = `${AssignmentAPIs.BASE_URL}Unassign/${workOrderId}`;
    return this.apiResponseHandler.put(apiAddress, false);
  };

  assignWorkOrder = async (workOrderAssignment: WorkOrderAssignmentSubmission): Promise<any> => {
    const url = new URL(
      `${workOrderAssignment.workOrderId}/DeviceUserId/${workOrderAssignment.deviceUserId}`,
      `${AssignmentAPIs.BASE_URL}Assign/`,
    );
    return this.apiResponseHandler.post(url.toString());
  };

  reassignWorkOrder = async (workOrderAssignment: WorkOrderAssignmentSubmission): Promise<any> => {
    const url = new URL(
      `${workOrderAssignment.workOrderId}/DeviceUserId/${workOrderAssignment.deviceUserId}`,
      `${AssignmentAPIs.BASE_URL}Reassign/`,
    );
    return this.apiResponseHandler.put(url.toString(), false);
  };

  async assignMultipleWorkOrders(workOrderAssignments: WorkOrderAssignmentSubmission[] | undefined): Promise<any> {
    if (workOrderAssignments == null || workOrderAssignments.length === 0) return;
    const assignWorkOrderPromises = workOrderAssignments.map((workOrderAssignment) =>
      this.assignWorkOrder(workOrderAssignment),
    );
    return await Promise.all(assignWorkOrderPromises);
  }

  async reassignMultipleWorkOrders(workOrderReassignments: WorkOrderAssignmentSubmission[] | undefined): Promise<any> {
    if (workOrderReassignments == null || workOrderReassignments.length === 0) return;
    const reassignWorkOrderPromises = workOrderReassignments.map((workOrderReassignment) =>
      this.reassignWorkOrder(workOrderReassignment),
    );
    return await Promise.all(reassignWorkOrderPromises);
  }
}
